<template>
    <div class="logindDalog">
        <el-dialog  :visible.sync="dialogTableVisible" width="450px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div class="content">
                <div class="title">
                    <div class="text">{{dataObj.title}}</div>
                    <img class="tanx" src="./images/tanx.png" alt="" @click="closeDialog()">
                </div>
                <div class="main">{{dataObj.content}}</div>
                <div class="btnBox">
					<div class="cz"  @click="closeDialog()">返回</div>
					<div class="cxybz" @click="confirm()">确认</div>
				</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "logindDalog",
        props: {
            dataObj: {
                type: Object,
                default: function () {
                    return {
                        title: '提示',
                        content: '弹框提示',
                        dalogType: 1
                    }
                },
            },
        },
        components: {
        },
        data() {
            return {
                dialogTableVisible: false
            }
        },
        computed: {
        },
        watch: {
            $route(to, from) {
            }
        },
        mounted() {
        },
        methods: {
            closeDialog() {
                this.dialogTableVisible = !this.dialogTableVisible
            },
            confirm() {
                this.$emit('confirm',this.dataObj)
            }
        },
        beforeDestroy() {}
    };
</script>

<style lang="less" scoped>
.content{
    background: #fff;
    .title{
        display: flex;
        align-items: center;
        height: 66px;
        border-bottom: solid 1px #E5E5E5;
        padding: 0 26px;
        .text{
            font-size: 16px;
            font-weight: 700;
            color: #333;
        }
        .tanx{
            width: 14px;
            height: 14px;
            margin-left: auto;
            cursor: pointer;
        }
    }
    .main{
        font-size: 16px;
        text-align: center;
        padding: 64px 26px;
    }
    .btnBox{
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 50px;
        .cz{
            font-size: 14px;
            color: #999999;
            text-align: center;
            width: 170px;
            height: 40px;
            line-height: 40px;
            border-radius: 4px;
            border: 1px solid #E5E5E5;
            margin: 0 10px;
            text-align: center;
            cursor: pointer;
        }
        .cxybz{
            width: 170px;
            height: 40px;
            background: #2196F3;
            line-height: 40px;
            border-radius: 4px;
            margin: 0 10px;
            color: #fff;
            text-align: center;
            cursor: pointer;
        }
	}
}
.logindDalog{
    /deep/ .el-dialog{
        border-radius: 16px;
        overflow: hidden;
        position: absolute;
        margin: auto !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    /deep/ .el-dialog__body{
        padding: 0;
    }
    /deep/ .el-dialog__header{
        padding: 0;
    }
}
</style>
